import { render } from "./TabInfo.vue?vue&type=template&id=79e2fa14&scoped=true"
import script from "./TabInfo.vue?vue&type=script&lang=js"
export * from "./TabInfo.vue?vue&type=script&lang=js"

import "./TabInfo.vue?vue&type=style&index=0&id=79e2fa14&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79e2fa14"]])

export default __exports__